import { Anchor, Container, Stack, Title } from "@mantine/core";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PlanComparison } from "@/features/plans/PlanComparison";

function Page() {
  const { session } = Route.useRouteContext();
  return <Container size="xl" py="xl"><Stack gap="lg">
    <Anchor renderRoot={(props) => <Link {...props} to="/settings" />}>Settings</Anchor>
    <Title order={1}>Plans</Title>
    <PlanComparison actorId={session.user.id} />
  </Stack></Container>;
}
export const Route = createFileRoute("/_authenticated/_protected/settings/plans")({ component: Page });
